module.exports = __webpack_public_path__ + "static/media/chaliceDefault.e536d5c4.png";